"use client";

import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";

// PUBLIC_URL is the Next basePath with a trailing slash (e.g. /hwapp/app/).
const authBasePath = `${process.env.NEXT_PUBLIC_PUBLIC_URL || "/"}cobrand-management/api/auth`;

// better-auth requires an absolute baseURL; window is absent during SSR prerender, so fall
// back to the dev origin there (only client-side calls matter).
export const cobrandAuthClient = createAuthClient({
    baseURL:
        typeof window === "undefined"
            ? `http://localhost:3000${authBasePath}`
            : `${window.location.origin}${authBasePath}`,
    plugins: [emailOTPClient()],
});
